/*
 * Filters invisible widgets from each row and removes rows that become empty.
 * @param {Array<Array>} rows - Row-based layout (array of arrays of widget configs)
 * @returns {Array<Array>} - Rows with only visible widgets, empty rows excluded
 */
const filterAndOrderWidgets = (rows = []) =>
  rows
    .map((row) => row.filter((config) => config.visible))
    .filter((row) => row.length > 0);

export default filterAndOrderWidgets;
